// src/data/planning/mebbisCodeMap.js

/**
 * REHBER360 - MEBBİS / e-Rehberlik KOD EŞLEME KATMANI
 *
 * ÖNEMLİ:
 * - Bu dosya faaliyet üretmez.
 * - Faaliyet isimlerini değiştirmez.
 * - Resmî faaliyet havuzuna yeni faaliyet eklemez.
 *
 * Faaliyetlerin gerçek kaynağı:
 * targetActivityCatalog.js
 * additionalGroupActivityCatalog.js
 *
 * Bu dosyanın tek görevi, mevcut resmî faaliyetlere
 * MEBBİS/e-Rehberlik ekranında kullanılan kodu göstermektir.
 */


// =========================================================
// HEDEFE BAĞLI GRUP ÇALIŞMALARI
// =========================================================

export const TARGET_ACTIVITY_MEBBIS_CODES = {

  student: {

    social_emotional:
      "ÖOVKg",

    academic:
      "ÖOVEg",

    career:
      "ÖOVMg"

  },


  parent:
    "DMVE",


  teacher:
    "DMÖE"

};


// =========================================================
// DİĞER B-GRUP ÇALIŞMALARI
// =========================================================

export const ADDITIONAL_GROUP_MEBBIS_CODES = {

  // -------------------------------------------------------
  // SINIF REHBERLİK PROGRAMI
  // -------------------------------------------------------

  class_guidance_preschool:
    "ÖSO",

  class_guidance_primary:
    "ÖSİ",

  class_guidance_middle_school:
    "ÖSOR",

  class_guidance_high_school:
    "ÖSL",


  // -------------------------------------------------------
  // ÖNLEYİCİ VE GELİŞİMSEL HİZMETLER
  // -------------------------------------------------------

  individual_recognition:
    "ÖOB",

  orientation_monitoring:
    "ÖOY",


  // -------------------------------------------------------
  // İYİLEŞTİRİCİ HİZMETLER
  // -------------------------------------------------------

  group_counseling:
    "İG",

  psychosocial_intervention:
    "İPg",


  // -------------------------------------------------------
  // DESTEK HİZMETLER
  // -------------------------------------------------------

  consultancy_other:
    "DMDE",

  program_management:
    "DP",

  cooperation_meetings:
    "DİT",

  cooperation_activities:
    "DİF",

  professional_development:
    "DG"

};


// =========================================================
// HEDEF FAALİYETİ KODU
// =========================================================

export const getTargetActivityMebbisCode = (
  activity
) => {

  if (!activity) {
    return null;
  }


  const audience =
    activity.audience;


  // -------------------------------------------------------
  // ÖĞRENCİ
  // -------------------------------------------------------

  if (
    audience === "student"
  ) {

    const developmentArea =
      activity.developmentArea;


    return (
      TARGET_ACTIVITY_MEBBIS_CODES
        .student
        ?.[developmentArea] ||
      null
    );
  }


  // -------------------------------------------------------
  // VELİ
  // -------------------------------------------------------

  if (
    audience === "parent"
  ) {

    return (
      TARGET_ACTIVITY_MEBBIS_CODES
        .parent
    );
  }


  // -------------------------------------------------------
  // ÖĞRETMEN
  // -------------------------------------------------------

  if (
    audience === "teacher"
  ) {

    return (
      TARGET_ACTIVITY_MEBBIS_CODES
        .teacher
    );
  }


  return null;
};


// =========================================================
// EK GRUP FAALİYETİ KODU
// =========================================================

export const getAdditionalGroupMebbisCode = (
  activity
) => {

  if (!activity) {
    return null;
  }


  /**
   * additionalGroupActivityCatalog.js
   * içerisinde doğrulanmış bir mebbisCode varsa
   * önce onu kullan.
   */

  if (
    activity.mebbisCode
  ) {

    return activity.mebbisCode;
  }


  /**
   * Yoksa faaliyet kategorisine göre
   * grup kodunu bul.
   */

  if (
    activity.category
  ) {

    return (
      ADDITIONAL_GROUP_MEBBIS_CODES[
        activity.category
      ] ||
      null
    );
  }


  return null;
};


// =========================================================
// ORTAK GÖSTERİM FONKSİYONU
// =========================================================

export const getMebbisDisplayCode = (
  activity
) => {

  if (!activity) {
    return null;
  }


  // -------------------------------------------------------
  // EK B-GRUP FAALİYETİ
  // -------------------------------------------------------

  if (
    activity.category
  ) {

    return (
      getAdditionalGroupMebbisCode(
        activity
      )
    );
  }


  // -------------------------------------------------------
  // HEDEFE BAĞLI FAALİYET
  // -------------------------------------------------------

  return (
    getTargetActivityMebbisCode(
      activity
    )
  );
};


// =========================================================
// KOD + FAALİYET ADI
// =========================================================

export const getMebbisActivityDisplayLabel = (
  activity
) => {

  if (!activity) {
    return "";
  }


  const code =
    getMebbisDisplayCode(
      activity
    );


  const label =
    activity.officialLabel ||
    "";


  if (!code) {
    return label;
  }


  return `[${code}] ${label}`;
};